/* eslint-disable */
import React from 'react';

import './shift-time-col.css';

import { useTranslate } from '../../../../../../../../../hooks';

import { Day } from '../../../../types';

import { baseTimeFormatting } from '../../../../../../../../../common/helper';
import { timeShiftLegends } from '../../../../utils';

import { DateField } from '../../../../../../../../../components';

const WeekOff = () => {
  const { translate } = useTranslate();

  return (
    <div className={`week-off-card`} style={timeShiftLegends[1]}>
      <p className="week-off-text">{translate('Week Off')}</p>
    </div>
  );
};

const OnLeave = () => {
  const { translate } = useTranslate();

  return (
    <div className={`leave-card`} style={timeShiftLegends[4]}>
      <p className="leave-text">{translate('On Leave')}</p>
    </div>
  );
};

const Holiday = () => {
  const { translate } = useTranslate();

  return (
    <div className={`holiday-card`} style={timeShiftLegends[6]}>
      <p className="holiday-text">{translate('Holiday')}</p>
    </div>
  );
};

const NoData = () => {
  return (
    <div className={`holiday-card`} style={timeShiftLegends[3]}>
      <p className="holiday-text">{timeShiftLegends[3]?.label}</p>
    </div>
  );
};

type Props = {
  value: Day;
};

export function ShiftTImeColumn({ value }: Props) {
  return (
    <div className="shift-time-container">
      {!value?.code ? (
        <NoData />
      ) : value?.isHoliday ? (
        <Holiday />
      ) : value?.onLeave ? (
        <OnLeave />
      ) : value?.isWeekOff ? (
        <WeekOff />
      ) : (
        <div
          className={`default-card default-text  ${
            value?.isToday && 'font-success'
          }`}
        >
          {value?.startTime ? (
            <DateField value={value?.startTime} format={baseTimeFormatting} />
          ) : (
            '-'
          )}
          &nbsp; -&nbsp;
          {value?.endTime ? (
            <DateField value={value?.endTime} format={baseTimeFormatting} />
          ) : (
            '-'
          )}
        </div>
      )}
    </div>
  );
}
